/* ==========================================================================
   Gutsi - "notify me when it is back" capture on sold-out finishes.
   Loaded from snippets/stylesheets.liquid with defer.
   Markup: sections/g-shop-colours.liquid (.g-fin__item--out).

   WHY: Matt, 14 Sep 2026 - "a thought on 'sold out' - we should give a click
   whereby you can share your email to be first to know when restocked ...
   a bit like drops on the adidas website when certain items go out of stock,
   should create urgency".

   Two of the three finishes (Dune, Granite) are sold out, and until now that
   was a dead end: the tile was dimmed and pointer-events:none, so the most
   interested visitor on the page hit a wall. This turns each sold-out tile
   into a capture.

   WHERE IT GOES: Klaviyo list XFzqV7 "Restock Notifications", single opt-in
   so the alert actually reaches them rather than dying at a confirmation
   step. Each profile carries a `restock_finish` property (Champagne / Dune /
   Granite) so one flow can segment by colour and only email the people who
   wanted the finish that came back.

   THE ENDPOINT is Klaviyo's client-side subscriptions API. It takes the
   PUBLIC company id only, never a private key - safe to ship in a theme. It
   returns 202 with an empty body on success, so do not try to parse JSON off
   a successful response.
   ========================================================================== */

(function () {
  var REVISION = '2024-10-15';

  function post(companyId, listId, email, finish) {
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(companyId), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: REVISION },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  properties: { restock_finish: finish }
                }
              }
            }
          },
          relationships: { list: { data: { type: 'list', id: listId } } }
        }
      })
    });
  }

  function setUp() {
    var items = document.querySelectorAll('.g-fin__item--out');
    if (!items.length) return;

    Array.prototype.forEach.call(items, function (item) {
      var toggle = item.querySelector('[data-restock-toggle]');
      var form = item.querySelector('[data-restock-form]');
      if (!toggle || !form) return;

      var input = form.querySelector('input[type="email"]');
      var msg = form.querySelector('[data-restock-msg]');
      var button = form.querySelector('button[type="submit"]');
      var finish = item.getAttribute('data-finish') || '';
      var companyId = form.getAttribute('data-company') || '';
      var listId = form.getAttribute('data-list') || '';

      toggle.addEventListener('click', function () {
        var opening = form.hidden;
        form.hidden = !opening;
        toggle.setAttribute('aria-expanded', opening ? 'true' : 'false');
        if (opening && input) input.focus();
      });

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!input || !input.value) return;
        if (!companyId || !listId) {
          if (msg) {
            msg.textContent = 'Sign-up is not configured yet.';
            msg.className = 'g-fin__msg is-error';
          }
          return;
        }

        if (button) button.disabled = true;
        if (msg) {
          msg.textContent = 'Just a moment...';
          msg.className = 'g-fin__msg';
        }

        post(companyId, listId, input.value.trim(), finish)
          .then(function (res) {
            /* 202 Accepted, empty body. Anything else is a genuine failure. */
            if (res.status >= 200 && res.status < 300) {
              form.innerHTML =
                '<p class="g-fin__msg is-done">You are on the list. We will email you the moment ' +
                (finish ? finish : 'it') +
                ' is back.</p>';
            } else {
              throw new Error('HTTP ' + res.status);
            }
          })
          .catch(function () {
            if (msg) {
              msg.textContent = 'That did not go through. Please try again.';
              msg.className = 'g-fin__msg is-error';
            }
            if (button) button.disabled = false;
          });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setUp);
  } else {
    setUp();
  }
})();